module.exports = __webpack_public_path__ + "static/media/max-icon.f4a7e88c.png";